
import Blog from '~/components/Common/Blog/'
import Content from '~/components/Common/Blog/BlogContent/HtmlFileType'

export default {
    name: 'DailyNewsBriefing',
    components: { Blog, Content },
}
